import AdminLiveRiderMapPage from '../../../components/admin/riders/AdminLiveRiderMapPage'

export default function RiderMap() {
  return <AdminLiveRiderMapPage fleet />
}
